import { render, staticRenderFns } from "./AdyApplePay.vue?vue&type=template&id=079e4d24&scoped=true"
import script from "./AdyApplePay.vue?vue&type=script&lang=js"
export * from "./AdyApplePay.vue?vue&type=script&lang=js"
import style0 from "./AdyApplePay.vue?vue&type=style&index=0&id=079e4d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079e4d24",
  null
  
)

export default component.exports